import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { exportGeneralVoucher } from 'lib/vouchers';

import * as Reports from 'reports/components';
import EmployeeVoucherSign from 'reports/containers/EmployeeVoucherSign';

import { getCompany, getSubcompany, getUser } from 'auth/selectors';

export class EmployeesAssetsReportRow extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
  };

  state = { collapsed: true };

  handleToggleCollapsed = () => this.setState({ collapsed: !this.state.collapsed });

  ctx = () => ({
    company: this.props.company,
    subcompany: this.props.subcompany,
    user: this.props.user,
  });

  // In the client's format (AutoSur has its own, without price; lib/vouchers).
  handleGeneratePDF = (record) => exportGeneralVoucher(record, this.ctx());
  handleGeneratePDF_two = (record) => exportGeneralVoucher(record, this.ctx(), { withPrice: true });

  render = () => (
    <Reports.EmployeesAssetsReportRow
      record={this.props.record}
      collapsed={this.state.collapsed}
      handleToggleCollapsed={this.handleToggleCollapsed}
      handleGeneratePDF={this.handleGeneratePDF}
      handleGeneratePDF_two={this.handleGeneratePDF_two}
      signAction={<EmployeeVoucherSign record={this.props.record} />}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  user: getUser(state),
});

export default connect(mapStateToProps, null)(EmployeesAssetsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/EmployeesAssetsReportRowContainer.js